import { createSlice } from "@reduxjs/toolkit";
import { logoutUser } from "../actions/account";
import { getCombinedGoalsAndLocations } from "../actions/combinedSchema";

const initialState = {
    error: false,
    isLoadingGetCombinedSchema: false,
    combinedSchemaData: [],
    combinedSchema: [],
    totalCount: null,
    totalCountAll: null,
    statusCount: {}
};

const combinedSchemaSlice = createSlice({
    name: "combinedSchema",
    initialState,
    extraReducers: {
        [getCombinedGoalsAndLocations.pending]: (state, action) => {
            state.isLoadingGetCombinedSchema=true;
            state.error = false;
        },
        [getCombinedGoalsAndLocations.fulfilled]: (state, action) => {
            state.combinedSchemaData = action?.payload?.data || [];
            state.combinedSchema = action?.payload?.schema || [];
            state.totalCount = action?.payload?.pagination?.total ?? null;
            state.totalCountAll = action?.payload?.pagination?.total ?? null;
            state.statusCount = action?.payload?.goal_status_count || {};
            state.isLoadingGetCombinedSchema = false;
            state.error = false;
        },
        [getCombinedGoalsAndLocations.rejected]: (state, action) => {
            state.isLoadingGetCombinedSchema = false;
            state.error = true;
        },
        [logoutUser.fulfilled]: (state) => {
            return initialState;
        },
        [logoutUser.rejected]: (state) => {
            return initialState;
        },
    },
});

export const getCombinedSchemaError = (state) => state.combinedSchem.error;
export const getIsLoadingGetCombinedSchema = (state) => state.combinedSchem.isLoadingGetCombinedSchema;
export const getCombinedSchemaData = (state) => state.combinedSchem.combinedSchemaData;
export const getCombinedSchemaSchema = (state) => state.combinedSchem.combinedSchema;
export const getCombinedTotalCount = (state) => state.combinedSchem.totalCount;
export const getCombinedTotalCountAll = (state) => state.combinedSchem.totalCountAll;
export const getCombinedStatusCount = (state) => state.combinedSchem.statusCount;


export default combinedSchemaSlice;
